import { gql } from "@apollo/client";

export const Get_Task_Statuses = gql`
  query GetTaskStatuses(
    $skip: Int
    $take: Int
    $where: TaskStatusFilterInput
    $order: [TaskStatusSortInput!]
  ) {
    taskStatuses(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        color
        isDefault
        createdOn
        sortOrder
      }
    }
  }
`;
export const Get_Task_Types = gql`
  query GetTaskTypes(
    $skip: Int
    $take: Int
    $where: TaskTypeFilterInput
    $order: [TaskTypeSortInput!]
  ) {
    taskTypes(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        createdOn
      }
    }
  }
`;
export const Get_Task_Priorities = gql`
  query GetTaskPriorities(
    $skip: Int
    $take: Int
    $where: TaskPriorityFilterInput
    $order: [TaskPrioritySortInput!]
  ) {
    taskPriorities(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        color
        createdOn
      }
    }
  }
`;
